
export enum GtsBundleOperationsEnum {
    'SEWING_IN' = 41,
    'SEWING_OUT' = 42,
    'WASHING_IN' = 61,
    'WASHING_OUT' = 62,
    'FINISHING_IN' = 71,
    'FINISHING_OUT' = 72
}

export const GtsBundleOperationsDisplayValues = {
    41: 'Sewing In',
    42: 'Sewing Out',
    61: 'Washing In',
    62: 'Washing Out',
    71: 'Finishing In',
    72: 'Finishing Out'
}